var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"spinner-border",class:("spinner-border-" + _vm.size),attrs:{"role":"status"}})}
var staticRenderFns = []

export { render, staticRenderFns }